import ProfileNestedSectionsTab from './ProfileNestedSectionsTab.js'

export default ProfileNestedSectionsTab
